// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-self{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.nav-self a p,.nav_logout{font-size:20px;font-weight:500;color:#9abdc2}.nav_link{border-right:1px solid #9abdc2;height:1.25rem}.nav_login,.nav_logout,.nav_registration{padding:0 1rem}", ""]);
// Exports
module.exports = exports;
